<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="15">
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
            :lg="24"
            :xl="24"
            class="leftfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div>
                  <div class="title_all" style="margin-bottom: 0">
                    <div class="title_left">{{ title }}</div>
                    <div class="title_more2">
                      <a href="/">首页</a>>{{ title }}
                    </div>
                    <div class="clearfix"></div>
                  </div>

                  <div class="side_container">
                    <div class="tgxz ten">
                      <div class="notice">
                        <ul>
                          <li v-for="(item, i) in recomList" :key="i">
                            <span class="rightfloat hidden-sm-and-down highgray"
                              >[{{ item.DateCreate }}]</span
                            >
                            <router-link
                              :to="'/digest?ArticleID=' + item.ArticleID"
                              v-html="item.Title"
                            ></router-link>
                          </li>
                        </ul>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                    <commonpage
                      :count="count"
                      @pageSize="pageSize"
                      @pageindex="index"
                      :index="paramas"
                    ></commonpage>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import commonpage from '../components/CommonPage'
export default {
  data() {
    return {
      title: '',
      recomList: [],
      count: 0,
      paramas: {
        PageSize: 10,
        PageIndex: 1,
      },
    }
  },
  components: {
    commonpage,
  },
  mounted() {
    this.GetRecomList(this.paramas.PageSize, this.paramas.PageIndex)
  },
  methods: {
    GetRecomList(PageSize, PageIndex) {
      var time = new Date().getTime()
      let data = {
        PageSize: PageSize,
        Type: 'Sort',
        Key: 'Recommended',
        PageIndex: PageIndex,
      }
      this.$store
        .dispatch('_getListb', data)
        .then((res) => {
          if (res.data.IsSuccess) {
            this.recomList = res.data.Data
            this.count = res.data.ItemCount
            this.title = res.data.Title
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    pageSize(val) {
      this.recomList = []
      this.paramas.PageSize = val
      this.GetRecomList(val, this.paramas.PageIndex)
    },
    index(val) {
      this.recomList = []
      this.paramas.PageIndex = val
      this.GetRecomList(this.paramas.PageSize, val)
    },
  },
}
</script>

<style scoped></style>
